import styled from 'styled-components';

export const Floor = styled.div`
  width: 100%;
  height: 25%;
  background-color: #f4ab7a;
  border-top: 20px solid #e09765;

  @media (max-height: 500px) {
    height: 20%;
  }

  @media (max-width: 639.98px) {
    height: 35%;
  }
`;
